/**
 * Instant, exact-coordinate scroll restoration helper for multi-page/infinite-scroll views.
 * Restores the exact pixel scroll coordinate where the user was previously before clicking into a game.
 */
export const restoreScrollPosition = (pathKey) => {
  const savedScroll = sessionStorage.getItem(`cg_scroll_${pathKey}`);
  const targetY = savedScroll ? parseFloat(savedScroll) : 0;

  if (targetY <= 0) return;

  const performInstantScroll = () => {
    if (window.__lenis) {
      window.__lenis.scrollTo(targetY, { immediate: true, force: true });
    }
    window.scrollTo({ top: targetY, behavior: 'instant' });
  };

  // 1. Instant execution before browser paint
  performInstantScroll();

  // 2. Next frame alignment for dynamic layout stability
  requestAnimationFrame(() => {
    performInstantScroll();
  });
};
